import React, { useState } from 'react'
import { A8Config } from './A8Config'
import { Functions } from './Functions'
import { Tabs } from 'antd'

const { TabPane } = Tabs

export const Config = () => {
  const [activeTab, setActiveTab] = useState('config')

  const tabs = [
    {
      title: 'Config',
      key: 'config',
      component: A8Config,
    },
    {
      title: 'Functions',
      key: 'functions',
      component: Functions,
    },
  ]

  return (
    <Tabs defaultActiveKey={activeTab} onChange={setActiveTab}>
      {tabs.map((tab) => {
        const { component: Component, title, key } = tab
        return (
          <TabPane key={key} tab={title}>
            <Component />
          </TabPane>
        )
      })}
    </Tabs>
  )
}
